// extracted by mini-css-extract-plugin
export var discard = "_2p-4";
export var muiTooltipTooltip = "_2p-6";
export var notificationBar = "_2p-3";
export var notificationContainer = "_2p-2";
export var saveButtonHoverSlotWrapper = "_2p-5";
export var show = "_2p-1";
export var spacer = "_2p-0";